export default "__VITE_ASSET__AwM6sQ4m__"